export const OfferUnsubscribeLoadingSpinnerUat = {
  spinner: 'offerUnsubscribeLoading.spinner',
}
